import { render, staticRenderFns } from "./AlternativeTextInfo.vue?vue&type=template&id=5cb56786"
import script from "./AlternativeTextInfo.vue?vue&type=script&lang=js"
export * from "./AlternativeTextInfo.vue?vue&type=script&lang=js"
import style0 from "./AlternativeTextInfo.vue?vue&type=style&index=0&id=5cb56786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports